/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAuthContext } from "@/context/auth/AuthContext";
import FullCalendar from "@fullcalendar/react";
import listPlugin from "@fullcalendar/list";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import interactionPlugin from "@fullcalendar/interaction";
import { openModal } from "@/pages/student/question/test/initiate/[id]";
import { formatTo12HourTime } from "@/context/utilities";
import { toast } from "react-toastify";

const SessionsCalendar = () => {
  const calendarRef = useRef();
  const { user } = useAuthContext();
  const [data, setData] = useState([]);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const fetchData = async () => {
    if (user && dateRange.start && dateRange.end) {
      try {
        const response = await axios.get(
          `/api/sessions?module=${user.batch.module}&status=Approved`,
          {
            params: {
              email: user.email,
              startDate: dateRange.start,
              endDate: dateRange.end,
            },
          }
        );

        if (response.status === 200) {
          setData(response.data.data);
        }
      } catch (err) {
        console.error("Fetching data failed.", err);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [user, dateRange]);

  const calendarOptions = {
    events: data?.length
      ? data.map((i) => {
          return {
            ...i,
            displayName: i.title,
            title: i?.subject?.[0]?.displayName,
          };
        })
      : [],
    datesSet: (info) => {
      setDateRange({
        start: info.startStr, // Set start date of the calendar view
        end: info.endStr, // Set end date of the calendar view
      });
    },
    plugins: [
      interactionPlugin,
      dayGridPlugin,
      timeGridPlugin,
      listPlugin,
      bootstrap5Plugin,
    ],
    initialView: "dayGridMonth",
    headerToolbar: {
      start: "prev title next",
      end: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
    },
    views: {
      week: {
        titleFormat: { year: "numeric", month: "long", day: "numeric" },
      },
    },
    editable: false,
    eventResizableFromStart: false,
    dragScroll: false,
    dayMaxEvents: 2,
    navLinks: true,
    eventClick({ event: clickedEvent }) {
      openModal("calendarSession");
      const session = clickedEvent._def.extendedProps;

      document.getElementById("sessionTitle").innerHTML = session.displayName;
      document.getElementById("sessionDate").innerHTML = new Date(
        clickedEvent._instance.range.start
      ).toDateString();
      document.getElementById("sessionFrom").innerHTML = formatTo12HourTime(
        clickedEvent._instance.range.start
      );
      document.getElementById("sessionTo").innerHTML = formatTo12HourTime(
        clickedEvent._instance.range.end
      );
      console.log(session.facultyData);
      document.getElementById("sessionHeading").innerHTML = session.facultyData
        ?.firstName
        ? session.facultyData?.firstName + " " + session.facultyData?.lastName
        : session.faculty;
      if (session.facultyData?.photoURL) {
        document.getElementById("sessionImage").src =
          session.facultyData?.photoURL;
        document.getElementById("sessionImage").srcset =
          session.facultyData?.photoURL;
      }
      document.getElementById("sessionSubject").innerHTML =
        session?.subject?.[0]?.displayName;
      document.getElementById("sessionDescription").innerHTML =
        session.description;
      document.getElementById("sessionLink").href = session.zoom.join_url;
      document.getElementById("sessionLink").target = "_blank";

      const resourcesContainer = document.getElementById(
        "sessionResourcesContainer"
      );
      const downloadBtn = document.getElementById("sessionDownloadBtn");

      if (session.notes && session.notes.length > 0) {
        resourcesContainer.style.display = "block";
        downloadBtn.onclick = async () => {
          const originalText = downloadBtn.textContent;
          downloadBtn.textContent = "Downloading...";
          downloadBtn.disabled = true;

          let downloadCount = 0;
          try {
            for (const note of session.notes) {
              if (note.Location) {
                try {
                  const response = await fetch(note.Location);
                  const blob = await response.blob();
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.href = url;
                  link.download = note.name || "download";
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                  downloadCount++;
                } catch (error) {
                  console.error("Download failed", error);
                  // Fallback to opening in new tab if fetch fails
                  const link = document.createElement("a");
                  link.href = note.Location;
                  link.target = "_blank";
                  link.download = note.name || "download";
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }
              }
            }
            if (downloadCount > 0) {
              toast.success(`Downloaded ${downloadCount} resources`);
            }
          } finally {
            downloadBtn.textContent = originalText;
            downloadBtn.disabled = false;
          }
        };
      } else {
        resourcesContainer.style.display = "none";
      }
    },
    customButtons: {
      sidebarToggle: {
        icon: "bi bi-list",
        click() {},
      },
      settings: {
        icon: "bi bi-gear",
        click: function () {},
      },
      addItem: {
        icon: "bi bi-calendar-plus",
        click: function () {},
      },
    },
    height: "auto",
    ref: calendarRef,
    eventTimeFormat: {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    },
  };

  return (
    <div className="rbt-calendar-content bg-color-white rbt-shadow-box">
      <div className="content">
        <div className="section-title">
          <h4 className="rbt-title-style-3">Upcoming Events</h4>
        </div>
        <div className="rbt-calendar">
          <FullCalendar {...calendarOptions} />
        </div>
      </div>
    </div>
  );
};

export default SessionsCalendar;
